<template>
  <div class="activity-edit-container">
    <h1 class="page-title">编辑活动</h1>
    <el-card class="form-card">
      <div v-if="loading" class="loading-container">
        <el-skeleton :rows="10" animated />
      </div>
      <div v-else>
        <el-alert title="活动编辑功能正在开发中" type="info" show-icon />
      </div>
    </el-card>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { ElMessage } from 'element-plus';

const router = useRouter();
const route = useRoute();
const loading = ref(true);
const activityId = ref('');

const fetchActivityDetail = async () => {
  loading.value = true;
  try {
    // 模拟数据，实际项目中需要调用真实API
    ElMessage.info('获取活动详情功能正在开发中');
    loading.value = false;
  } catch (error) {
    ElMessage.error('获取活动详情失败：' + (error.message || '未知错误'));
    router.push('/manage/activities');
    loading.value = false;
  }
};

onMounted(() => {
  activityId.value = route.params.id;
  fetchActivityDetail();
});
</script>

<style scoped>
.activity-edit-container {
  padding: 20px;
}

.page-title {
  font-size: 24px;
  margin-bottom: 20px;
  color: #333;
}

.form-card {
  max-width: 100%;
}

.loading-container {
  padding: 20px 0;
}
</style>